import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadChildren: () => import('./pages/home/home.module').then( m => m.HomePageModule)
  },
  {
    path: 'kitchen/:type',
    loadChildren: () => import('./pages/kitchen/kitchen.module').then( m => m.KitchenPageModule)
  },
  {
    path: 'door',
    loadChildren: () => import('./pages/door/door.module').then( m => m.DoorPageModule)
  },
  {
    path: 'mail',
    loadChildren: () => import('./pages/mail/mail.module').then( m => m.MailPageModule)
  },
  {
    path: 'garden',
    loadChildren: () => import('./pages/garden/garden.module').then( m => m.GardenPageModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
